import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from 'components/Typography';
import { Key } from 'react';
import * as styles from './OurLeadershipTeam.module.scss';
import OurLeadershipCard from './OurLeadershipCard';

import ronAvif from './ron.avif';
import ronWebp from './ron.webp';
import ronJpg from './ron.jpg';

import carlyAvif from './carly.avif';
import carlyWebp from './carly.webp';
import carlyJpg from './carly.jpg';

import jamesAvif from './james.avif';
import jamesWebp from './james.webp';
import jamesJpg from './james.jpg';

import willAvif from './will.avif';
import willWebp from './will.webp';
import willJpg from './will.jpg';

import meaghanAvif from './meaghan.avif';
import meaghanWebp from './meaghan.webp';
import meaghanJpg from './meaghan.jpg';

const leaders = [
  {
    bio1: 'Ron is passionate about building great companies that help people have authentic, organic, real-world experiences. In 2005, Ron co-founded Liftopia, the global leader in ski lift ticket bookings, and most recently was Head of Growth at Yelp Reservations. Ron is committed to mentoring other entrepreneurs. He frequently advises members of the 500 Startups community, and speaks at industry and thought leadership events.',
    bio2: 'Ron attended UCLA, where he earned his bachelor’s degree in Mass Communications, and lives in the East Bay, California, with his wife Jenny and their three children. Ron loves riding his mountain bike, and his all-time favorite trail is the Na Pali Coast Trail.',
    name: <FormattedMessage defaultMessage="Ron Schneidermann" />,
    photoAvif: ronAvif,
    photoJpg: ronJpg,
    photoWebp: ronWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Executive Officer" />
  },
  {
    bio1: '',
    bio2: '',
    name: <FormattedMessage defaultMessage="Carly Smith Costello" />,
    photoAvif: carlyAvif,
    photoJpg: carlyJpg,
    photoWebp: carlyWebp,
    pronouns: <FormattedMessage defaultMessage="(she/her)" />,
    title: <FormattedMessage defaultMessage="Chief Marketing Officer" />
  },
  {
    bio1: '',
    bio2: '',
    name: <FormattedMessage defaultMessage="James Graham" />,
    photoAvif: jamesAvif,
    photoJpg: jamesJpg,
    photoWebp: jamesWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Technology Officer" />
  },
  {
    bio1: '',
    bio2: '',
    name: <FormattedMessage defaultMessage="Will Masterson" />,
    photoAvif: willAvif,
    photoJpg: willJpg,
    photoWebp: willWebp,
    pronouns: <FormattedMessage defaultMessage="(he/him)" />,
    title: <FormattedMessage defaultMessage="Chief Financial Officer" />
  },
  {
    bio1: '',
    bio2: '',
    contact: 'mailto:press@alltrails.com',
    name: <FormattedMessage defaultMessage="Meaghan Praznik" />,
    photoAvif: meaghanAvif,
    photoJpg: meaghanJpg,
    photoWebp: meaghanWebp,
    pronouns: <FormattedMessage defaultMessage="(she/her)" />,
    title: <FormattedMessage defaultMessage="Head of Communications" />
  }
];

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A10812&t=cQ6ofstqefHmuy2U-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=2506%3A11457&t=aadNlnIKQJkCzSxu-4
export default function OurLeadershipTeam() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="heading700">
          <FormattedMessage defaultMessage="Our leadership team" />
        </Typography>
        <Typography className={styles.copy} component="div" variant="paragraph300">
          <FormattedMessage defaultMessage="Our wild spaces are for everyone, and as a team of outdoor lovers, our leadership team is proud to champion this guiding principle." />
        </Typography>
        <div className={styles.leaders}>
          {leaders.map((leader, index) => (
            <OurLeadershipCard leader={leader} key={index as Key} />
          ))}
        </div>
      </div>
    </div>
  );
}

export type Leader = typeof leaders[number];
